import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

function ResetPassword() {
    const { token } = useParams();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');

    const handleResetPassword = async (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            setMessage('Passwords do not match');
            return;
        }

        try {
            const endpoint = 'https://iyqesl2ns3.execute-api.us-east-1.amazonaws.com/Prod/ResetPassword';
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token: token, newPassword: newPassword }),
            });

            const data = await response.json();
            if (response.ok) {
                setMessage(data.message || 'Password reset successful');
            } else {
                const error = data;
                setMessage(`Error: ${error.message || response.statusText}`);
            }
        } catch (err) {
            setMessage('Reset error');
        }
    };

    return (
        <form onSubmit={handleResetPassword}>
            <h2>Reset Password</h2>
            <input type="password" placeholder="New Password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required />
            <input type="password" placeholder="Confirm Password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
            <button type="submit">Reset Password</button>
            <p>{message}</p>
        </form>
    );
}

export default ResetPassword;
